(function (app) {

    app.provider("figUiSrefModalService",
        [
            function () {
                this.$get = [
                    function () {
                        return {};
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line